import { filterValidImageFiles, IMAGE_ACCEPT_ATTR, IMAGE_TYPES_HELPER_TEXT } from "./imageUploadRules";

export { IMAGE_ACCEPT_ATTR, IMAGE_TYPES_HELPER_TEXT };

/** Clears the input; shows Chakra toasts for rejects. Resolves accepted `File[]`. */
export function consumeValidatedImagesFromEvent(e, toast) {
  const files = Array.from(e.target.files || []);
  e.target.value = "";
  return filterValidImageFiles(files, (msg) => {
    toast({
      title: "Invalid image",
      description: msg,
      status: "error",
      duration: 6000,
      isClosable: true,
      position: "top",
    });
  });
}
